//import { fetchApi } from '../apiService';
import { menuData } from '../mocks/menus';

export const getMenuData = async (userTokenAuth) => {
    let response = {status:'Ok', data:{}, errorMessage:''}
    return {...response, data:menuData}
    
}